
import { Options } from "vue-class-component";
import { Question } from "../../../../model/Question.model";
import Base from "../../../../components/base/Base.vue";
import Answers from "./answers/Answers.vue";
import { Answer } from "../../../../model/Answer.model";
import { computed, watchEffect } from "vue";
import { ChallengeSettings } from "../../../../model/ChallengeSettings.model";
import { ChallengeType } from "../../../../enum/challenge.type";
import ChallengeService from "../../../../services/challenge.service";
import { take } from "rxjs/internal/operators/take";
@Options({
  props: ["question", "index", "imageQuestion"],
  components: {
    Answers
  }
})
export default class CardQuestion extends Base {
  question!: Question;
  index!: number;
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  addAnswer() {
    this.question.answers.push({ name: "" } as Answer);
  }

  checkChallengeType() {
    const name = this.settingsChallenge.name.toLowerCase();
    return {
      quiz: name === ChallengeType.quiz,
      poll: name === ChallengeType.poll,
      openEnded: name === ChallengeType.openEnded,
      random: name === ChallengeType.random
    };
  }

  created() {
    watchEffect(() => {
      ChallengeService.getQuestion
        .pipe(take(1))
        .subscribe((question: Question) => {
          question = {
            ...question
          };
          ChallengeService.setQuestion(question, question.index);
        });
    });
  }
}
